import { AddCardSuccess } from "@widgets/payments/ui/add-card-success/add-card-success"

export const AddCardSuccessPage = () => {	
	return <AddCardSuccess />
}
